export default __webpack_public_path__ + "static/media/seif.4f73748c.svg";